import { Home } from "../pages/home";
import { LaborLawLandingPage } from "../pages/laborLaw";
import { LoginPage } from "../pages/login";
import { PensionLawLandingPage } from "../pages/pensionLaw";

export const stackRoutes = [
    {
        path: '/',
        element: <Home />,
    },
    {
        path: '/trabalhista',
        element: <LaborLawLandingPage />
    },
    {
        path: '/previdenciario',
        element: <PensionLawLandingPage />
    },
    {
        path: '/login',
        element: <LoginPage />
    }
];